import { useEffect, useState } from "react";

export function useDarkMode() {
  const [dark, setDark] = useState(
    () => localStorage.getItem("orgaviya_theme") === "dark"
  );
  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("orgaviya_theme", dark ? "dark" : "light");
  }, [dark]);
  return [dark, setDark];
}
